import { withTranslation } from "react-i18next"
import { Link } from 'react-router-dom' 
import { useEffect } from "react";
import { Divider } from "antd";
import { useState } from "react";
import { FilePdfOutlined } from "@ant-design/icons";
import styled from "styled-components";

import * as Styled from '../../../Home/styled';

import { get } from "library/endpoints";
import Text from "components/Text";
import moment from "moment";
import Title from "components/Title";

const StyledLink = styled(Link)`
  font-size: 14px;
  color: #53b297;

  &:hover {
    color: #13a9c6 !important;
  }
`;

const StyledLinkText = styled(Text)`
  color: #53b297;
  &:hover {
    color: #13a9c6 !important;
  }
`;

/**
 * BillDetails
 * @param {*} props 
 * @returns 
 */
const BillDetails = (props) => {
  const billId = props.match.params.id;

  const [bill, setBill] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchData();
  }, []) // eslint-disable-line

  const fetchData = async () => {
    try {
      const response = await get(`/frontend/basket/bills/${billId}`);
      const responseOrders = await get(`/frontend/basket/orders/${billId}`);
      console.log(response.data)
      setBill(response.data);
      setOrders(responseOrders.data)
    } catch (error) {
      console.log(error)
    }
  }

  const handleOnDownloadInvoice = () => {
    window.open(`${process.env.REACT_APP_S3_FILES_URL}invoice-${bill._id}`);
  }
  
  if (!bill) {
    return null;
  }

  console.log(orders);

  return (
    <>
      <StyledLink to={`/orders`}>{`< Mes commandes`}</StyledLink>

      <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
        <Title size={18}>Détail de votre commande du {moment(bill.created_at).format('DD/MM/YYYY')}</Title>
        <Divider style={{ margin: 10 }} />
        
        {
          bill._lines.map((item) => (
            <>
              <Styled.BasketItem>
                <Text size={14} style={{ marginLeft: 10, marginTop: 5 }}>{item.quantity} x </Text>
                <Text size={14} style={{ marginLeft: 10, marginTop: 5 }}>{item.label}</Text>
                <Text size={15} style={{ marginLeft: 'auto', marginTop: 5 }}>{item.price * item.quantity}€</Text>
              </Styled.BasketItem>
              <Divider style={{ margin: 10 }} />
            </>
          ))
        }

        {
          bill._products.map((item) => (
            <>
              <Styled.BasketItem>
                <Text size={14} style={{ marginLeft: 10, marginTop: 5 }}>{item.quantity} x </Text>
                <Text size={14} style={{ marginLeft: 10, marginTop: 5 }}>{item.label.fr}</Text>
                <Text size={15} style={{ marginLeft: 'auto', marginTop: 5 }}>{item.price * item.quantity}€</Text>
              </Styled.BasketItem>
              <Divider style={{ margin: 10 }} />
            </>
          ))
        }

        {
          bill._mount_quotations.map((item) => (
            <>
              <Styled.BasketItem>
                <Text size={14} style={{ marginLeft: 10, marginTop: 5 }}>{item.quantity} x </Text>
                <Text size={14} style={{ marginLeft: 10, marginTop: 5 }}>{item.variant.name_fr}</Text>
                <Text size={15} style={{ marginLeft: 'auto', marginTop: 5 }}>{item.public_price * item.quantity}€</Text>
              </Styled.BasketItem>
              <Divider style={{ margin: 10 }} />
            </>
          ))
        }

        <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
          <Text size={16}>Montant total TTC</Text>
          <Text size={16} style={{ marginLeft: 'auto' }} color="#176b87" >{bill.amount}€</Text>
        </div>
      </div>

      {
        orders.filter((o) => o.provider === 'picanova' && o.shippingData).map((o) => (
          <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
              {
                o.shippingData.map((sd) => (
                  <div style={{ display: 'flex', }}>
                    <Text bold size={13}>Numéro de suivi : </Text>
                    <a style={{ marginLeft: 5, fontSize: 13 }} href={sd.tracking_url} target="_blank" rel="noopener noreferrer">{sd.tracking_number}</a>
                  </div>
                ))
              }
          </div>
        ))
      }

      <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
        <div style={{ display: 'flex'}} onClick={() => handleOnDownloadInvoice()}>
          <FilePdfOutlined style={{ fontSize: 16, marginRight: 10 }} />
          <StyledLinkText size={14} cursor="pointer">Télécharger la facture</StyledLinkText>
        </div>
      </div>
    </>
  )
}

export default withTranslation()(BillDetails);